import type { ReactNode } from 'react';
import { createContext } from 'react';

export type ToastType = 'default' | 'success' | 'error';

export type ToastContextValue = {
  show: (message: ReactNode, duration?: number) => void;
  success: (message: ReactNode, duration?: number) => void;
  error: (message: ReactNode, duration?: number) => void;
};

export const ToastContext = createContext<ToastContextValue | null>(null);
